import { useMemo, useState } from 'react'
import { Card, Container } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import KAccess from '../components/KAccess'
import KButton from '../components/KButton'
import { setAccessToken, showKAlert } from '../helpers'
import { t } from '../locale'
import { fetchAccessForClient, validatePinCodeClient } from '../service/client'

type Props = {
  stammdatenType: 'company' | 'person'
}

export default function StammdatenPinAccess({ stammdatenType }: Props) {
  const navigate = useNavigate()
  const { clientId, email } = useParams()

  const [pin, setPin] = useState('')
  const [accessModalOpen, setAccessModalOpen] = useState(false)
  const [sending, setSending] = useState(false)

  const targetPath = useMemo(() => {
    if (!clientId) return '/client/stammdaten'
    return `/client/stammdaten/${stammdatenType}/${clientId}`
  }, [clientId, stammdatenType])

  const handleSendCode = async () => {
    if (!email || !clientId) {
      navigate(targetPath, { replace: true })
      return
    }

    setSending(true)
    try {
      const result = await fetchAccessForClient(email)

      if (result?.accessToken) {
        setAccessToken(result.accessToken)
        localStorage.setItem('clientId', clientId)
        localStorage.setItem('email', email)
        setPin(result.pinCode)
        setAccessModalOpen(true)
        return
      }

      showKAlert('danger', 'serverError')
    } catch (error) {
      console.error('Error sending pin code:', error)
      showKAlert('danger', 'serverError')
    } finally {
      setSending(false)
    }
  }

  const checkPin = async (pinCode: number) => {
    try {
      const result = await validatePinCodeClient(pinCode, localStorage.getItem('email') || email)

      if (result?.accessToken) {
        setAccessToken(result.accessToken)
        setAccessModalOpen(false)
        navigate(targetPath, { replace: true })
      }
    } catch (error) {
      console.error('Error validating pin code:', error)
    }
  }

  return (
    <Container className='pt-4'>
      <Card className='shadow-sm mx-auto w-50'>
        <Card.Body className='p-4 text-center'>
          <h4 className='mb-3 text-primary'>{t('accessDocument')}</h4>
          <p className='text-muted mb-4'>{t('stammdatenSendCodeHint')}</p>

          <KButton
            id='btn-send-pin-manual'
            icon='envelope'
            variant='primary'
            className='text-white'
            disabled={sending}
            label={sending ? t('loading') : t('sendCodeToMe')}
            onClick={handleSendCode}
          />
        </Card.Body>
      </Card>

      {accessModalOpen && (
        <KAccess
          show={accessModalOpen}
          title={t('pinCodeSent')}
          pin={pin}
          onConfirm={(enteredPin: any) => {
            checkPin(enteredPin)
          }}
          onClose={() => setAccessModalOpen(false)}
        />
      )}
    </Container>
  )
}
